import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from '../footer/footer.component';

@Component({
	selector: 'app-page-layout',
	templateUrl: './page-layout.component.html',
	imports: [RouterOutlet, FooterComponent],
})
export class PageLayoutComponent {}
